import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPreloadersStore from './preloaders';
import ICategory from '@interfaces/ICategory';
import { get } from 'lodash';

export const reset = createEvent('Roles store reset');

export const getList = createEffect({
  name: 'getList',
  async handler() {
    const response = await request(api.roles.getList, {});
    return response;
  },
});

const preloaders = createPreloadersStore([getList]);

const list = createStore<ICategory[]>([])
  .on(getList.done, (state, { result }) => get(result, ['data', 'body']))
  .reset(reset);

const roles = combine({ preloaders, list });

export default roles;
